export default "__VITE_ASSET__Dygh39gW__"